import commonResource from '../../../../locales/th/common.json';
import navigationResource from '../../../../locales/th/navigation.json';
import { NavBarItem } from './navBarItem';
import { LandingPageTypes } from '../../../../common/helpers/domain/landingPages';

export function getHeaderMenu(): NavBarItem[] {
  return [
    {
      title: commonResource.propertyTypes.condominium,
      key: LandingPageTypes.CondoPage,
      customLink: `/${commonResource.propertyTypes.condominium}/`,
    },
    {
      title: commonResource.propertyTypes.house,
      key: LandingPageTypes.HousePage,
      customLink: `/${commonResource.propertyTypes.house}/`,
    },
    {
      title: navigationResource.navigationLabel.projectResearch.main,
      key: LandingPageTypes.ProjectResearchPage,
      customLink: `/${navigationResource.landingPageRoutes.projectResearch.main}/`,
      items: [
        {
          title: navigationResource.navigationLabel.projectResearch.preview,
          key: LandingPageTypes.PreviewPage,
          customLink: `/${navigationResource.landingPageRoutes.projectResearch.main}/${navigationResource.landingPageRoutes.projectResearch.preview}/`,
        },
        {
          title: navigationResource.navigationLabel.projectResearch.review,
          key: LandingPageTypes.ReviewPage,
          customLink: `/${navigationResource.landingPageRoutes.projectResearch.main}/${navigationResource.landingPageRoutes.projectResearch.review}/`,
        },
        {
          title: navigationResource.navigationLabel.projectResearch.pov,
          key: LandingPageTypes.PointOfViewPage,
          customLink: `/${navigationResource.landingPageRoutes.projectResearch.main}/${navigationResource.landingPageRoutes.projectResearch.pov}`,
        },
      ],
    },
    {
      title: navigationResource.navigationLabel.locationInsight.main,
      key: LandingPageTypes.LocationInsightPage,
      customLink: `/${navigationResource.landingPageRoutes.locationInsight.main}/`,
      items: [
        {
          title: navigationResource.navigationLabel.locationInsight.zone,
          key: LandingPageTypes.ZonesPage,
          customLink: `/${navigationResource.landingPageRoutes.locationInsight.main}/${navigationResource.landingPageRoutes.locationInsight.zone}/`,
        },
        {
          title: navigationResource.navigationLabel.locationInsight.trainline,
          key: LandingPageTypes.TrainlinesPage,
          customLink: `/${navigationResource.landingPageRoutes.locationInsight.main}/${navigationResource.landingPageRoutes.locationInsight.trainline}/`,
        },
      ],
    },
    {
      title: navigationResource.navigationLabel.news.main,
      key: LandingPageTypes.NewsPage,
      customLink: `/${navigationResource.landingPageRoutes.news.main}/`,
      items: [
        {
          title: navigationResource.navigationLabel.news.propertyNews,
          key: LandingPageTypes.PropertyNewsPage,
          customLink: `/${navigationResource.landingPageRoutes.news.main}/${navigationResource.landingPageRoutes.news.propertyNews}/`,
        },
        {
          title: navigationResource.navigationLabel.news.generalNews,
          key: LandingPageTypes.GeneralNewsPage,
          customLink: `/${navigationResource.landingPageRoutes.news.main}/${navigationResource.landingPageRoutes.news.generalNews}/`,
        },
      ],
    },
    {
      title: navigationResource.navigationLabel.guides.main,
      key: LandingPageTypes.GuidesPage,
      customLink: `/${navigationResource.landingPageRoutes.guides.main}/`,
      items: [
        {
          title: navigationResource.navigationLabel.guides.buyAndSell,
          key: LandingPageTypes.BuyAndSellPage,
          customLink: `/${navigationResource.landingPageRoutes.guides.main}/${navigationResource.landingPageRoutes.guides.buyAndSell}/`,
        },
        {
          title: navigationResource.navigationLabel.guides.finance,
          key: LandingPageTypes.FinancePage,
          customLink: `/${navigationResource.landingPageRoutes.guides.main}/${navigationResource.landingPageRoutes.guides.finance}/`,
        },
        {
          title: navigationResource.navigationLabel.guides.investment,
          key: LandingPageTypes.InvestmentPage,
          customLink: `/${navigationResource.landingPageRoutes.guides.main}/${navigationResource.landingPageRoutes.guides.investment}/`,
        },
      ],
    },
    {
      title: navigationResource.navigationLabel.decor.main,
      key: LandingPageTypes.DecorsPage,
      customLink: `/${navigationResource.landingPageRoutes.decor.main}/`,
      items: [
        {
          title: navigationResource.navigationLabel.decor.interiorInspiration,
          key: LandingPageTypes.InteriorInspirationPage,
          customLink: `/${navigationResource.landingPageRoutes.decor.main}/${navigationResource.landingPageRoutes.decor.interiorInspiration}/`,
        },
        {
          title: navigationResource.navigationLabel.decor.renovation,
          key: LandingPageTypes.RenovationPage,
          customLink: `/${navigationResource.landingPageRoutes.decor.main}/${navigationResource.landingPageRoutes.decor.renovation}/`,
        },
        {
          title: navigationResource.navigationLabel.decor.maintenance,
          key: LandingPageTypes.MaintenancePage,
          customLink: `/${navigationResource.landingPageRoutes.decor.main}/${navigationResource.landingPageRoutes.decor.maintenance}/`,
        },
      ],
    },
    {
      title: commonResource.eventsInformation.title,
      key: LandingPageTypes.EventPage,
      customLink: `/${commonResource.eventsInformation.link}/`,
    },
  ];
}
